// extracted by mini-css-extract-plugin
module.exports = {"LanguageButton":"LanguageButton_LanguageButton__3-nle"};